$(function () {
  $('.b-docs-list, .b-filter-wrap').each(initDocFilter);

  function initDocFilter() {
    const $this = $(this);

    const items = $('[data-doc]', $this);

    const filterParams = {};

    $this.on('click', '[data-filter]', function (e) {
      e.preventDefault();
      clickHandler.call(this, items, filterParams, $this);
    });
  }

  function clickHandler(items, filterParams, $container) {

    const {filterType, filter} = this.dataset;

    if (filter === 'ALL') {
      $(this).addClass('is-active');
    } else {
      $(this).toggleClass('is-active');
    }


    $(`[data-filter-type="${filterType}"]`, $container).not(this).removeClass('is-active');

    if ($(this).hasClass('is-active')) {
      filterParams[filterType] = filter === 'ALL' ? null : filter;
    } else {
      filterParams[filterType] = null;
    }

    filterItems(items, filterParams);
  }

  function filterItems(items, filterParams) {
    items.each(function () {
      const {docYear, doc} = this.dataset;

      let isShow = true;
      if (filterParams.year && docYear !== filterParams.year ) {
        isShow = false;
      }

      if (filterParams.tag && doc !== filterParams.tag ) {
        isShow = false;
      }

      if (isShow) {
        $(this).show();
      } else {
        $(this).hide();
      }
    })

    $('.b-filter-wrap').each(initDecor);

    window.onresize = function() {
      $('.b-filter-wrap').each(initDecor);
    }

  }
  let setDecorPosition = function (items) {
    items.each(function() {
      let decor = $(this).find('.top-five-table__decor') || null;
      let tbodyTopFive = $(this).find('.top-five-table .b-projects-table__body') || null;
      if(decor && tbodyTopFive.length > 0) {
        let positionTop = tbodyTopFive ? tbodyTopFive.position().top : 0;
        decor.height(tbodyTopFive.height());
        decor.css({top: positionTop});
      }
    });
  }
  function initDecor() {
    const $this = $(this);

    const items = $('[data-doc]', $this);
    setDecorPosition(items);
    $('.top-five-table__decor').show();
  }
});
